
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/the-shy-die",
      function () {
        return require("private-next-pages/archive/the-shy-die.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/the-shy-die"])
      });
    }
  